import React, {useMemo, useState} from 'react'


const OfferContext = React.createContext()
OfferContext.displayName = 'OfferContext'

const OfferContextProvider = ({children}) => {
    const [materials, setMaterials] = useState([])
    const [offerInfo, setOfferInfo] = useState({})
    const [stockList, setStockList] = useState([])

    const calculateSubTotal = () => {
        let subTotalObj = {
            "EUR": [],
            "USD": [],
            "TRY": []
        }

        materials.map(item => {
            if (item && item.data) subTotalObj[item.data.currency].push(item.rowTotal)
        })

        return subTotalObj
    }

    const calculateRowTotals = () => {
        materials.map(item => {
            if (item && item.data) {
                if (item.hasOwnProperty('gift') && item.gift) {
                    item.rowTotal = 0
                } else {
                    const total = (item.hasOwnProperty('unitPrice') ? item.unitPrice : item.data.price) * item.quantity
                    const [discount, secondDiscount] = [item.data.discount || 0 , item.data.discount2 || 0]
                    const priceIterable = [total, discount, secondDiscount]
                    item.rowTotal = priceIterable.reduce(rowTotalReducer)
                }
            }
        })
    }

    const rowTotalReducer = (acc, crr) => acc - ((acc * crr) / 100)

    useMemo(() => calculateRowTotals(), [materials])
    const subTotal = useMemo(() => calculateSubTotal(), [materials])

    const values = {
        offerInformation: [offerInfo, setOfferInfo],
        materialInformation: [materials, setMaterials],
        subTotal: subTotal,
        stocks: [stockList, setStockList]
    }

    return (
        <OfferContext.Provider value={values}>
            {children}
        </OfferContext.Provider>
    )
}
export {OfferContext, OfferContextProvider}